<div *ngIf="config"
     class="app-page-container">
  <div class="d-flex flex-row justify-content-between">
    <div class="flex-grow-1 mr-1">
      <app-menu-link-list (changes)="onModifyMenuLinks($event)" [menuItems]="config.menuItems"></app-menu-link-list>

      <h3>External Links</h3>
      <app-menu-link-display (changes)="onModifyBlueBookLink($event)" [menuItem]="config.blueBookLink"
                             [title]="'Blue Book Link'">
      </app-menu-link-display>
      <app-menu-link-display (changes)="onModifyAccessoryCatalogLink($event)" [menuItem]="config.accessoryCatalogLink"
                             [title]="'Accessory Catalog Link'">
      </app-menu-link-display>
    </div>

    <div class="flex-grow-1 border-left pl-1">
      <h3>Featured Accessories</h3>
      <div class="mb-3">
        <button
          [class.btn-success]="selectedTab == 'new'"
          [class.btn-outline-success]="selectedTab != 'new'"
          class="btn mr-3"
          (click)="selectedTab = 'new'"
        >
          New
        </button>
        <button
          [class.btn-success]="selectedTab == 'used'"
          [class.btn-outline-success]="selectedTab != 'used'"
          class="btn mr-3"
          (click)="selectedTab = 'used'"
        >
          Used
        </button>
        <button
          [class.btn-success]="selectedTab == 'certified'"
          [class.btn-outline-success]="selectedTab != 'certified'"
          class="btn"
          (click)="selectedTab = 'certified'"
        >
          Certified
        </button>
      </div>
      
      <div>
        <div *ngIf="config.featuredAccessoriesNew && selectedTab == 'new'">
          <app-featured-accessories (changes)="onModifyAccessoriesNew($event)"
                                    [accessories]="config.featuredAccessoriesNew">
          </app-featured-accessories>
        </div>
        <div *ngIf="config.featuredAccessoriesUsed && selectedTab == 'used'">
          <app-featured-accessories (changes)="onModifyAccessoriesUsed($event)"
                                    [accessories]="config.featuredAccessoriesUsed">
          </app-featured-accessories>
        </div>
        <div *ngIf="config.featuredAccessoriesCertified && selectedTab == 'certified'">
          <app-featured-accessories (changes)="onModifyAccessoriesCertified($event)"
                                    [accessories]="config.featuredAccessoriesCertified">
          </app-featured-accessories>
        </div>
      </div>
    </div>
  </div>
</div>
